import { LogoWrapper, AuthenticationInfo } from 'components/authentication/styled';
import React from 'react';
import { useLocale } from 'locale';
import { Link } from 'ds/components/link';
import { AuthCodeWrapper, AuthenticationInfoHeader, SkipLink } from './styled';
import { AuthenticationModalType } from '../types';
import OopsIcon from 'assets/svg/oops.svg';
import { authModalAuthSourceVariablesSelector } from 'store/state/app/selectors';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { State } from 'store/state';


interface AuthenticationBlockProps {
  setActiveModal: (type: AuthenticationModalType) => void;
  remainedTTl?: number | null;
}

const AuthenticationBlock: React.FC<AuthenticationBlockProps> = (props) => {
  const {
    setActiveModal,
    remainedTTl,
  } = props;
  const { t } = useLocale();

  const hours = remainedTTl ? Math.ceil(remainedTTl / 3600) : 32;

  const handleBackToLogin = () => {
    setActiveModal(AuthenticationModalType.SignIn);
  };

  return (
    <AuthCodeWrapper>
      <LogoWrapper>
        <OopsIcon />
      </LogoWrapper>
      <AuthenticationInfoHeader weight="bold">
        {t('authentication.block.title')}
      </AuthenticationInfoHeader>
      <AuthenticationInfo useDefaultMarginT>{t('authentication.block.info', { hours })}</AuthenticationInfo>
      <SkipLink>
        <Link simple onClick={handleBackToLogin}>{t('authentication.block.skip')}</Link>
      </SkipLink>
    </AuthCodeWrapper>
  );
};

const TTLSelector = createSelector(
  authModalAuthSourceVariablesSelector,
  (variables) => variables ? variables.verificationTTL : null
);

const mapStateToProps = (state: State) => ({
  remainedTTl: TTLSelector(state),
});

export default connect(mapStateToProps)(AuthenticationBlock);
